import React from "react";
import { StyledButton } from "./styles";

type ButtonProps = {
  label: string;
  disabled?: boolean;
  type?: "submit" | "reset" | "button";
  onClick?: () => void; // ✅ prop opcional
};

const Button: React.FC<ButtonProps> = ({
  type = "button",
  label,
  disabled = false,
  onClick,
}) => {
  return (
    <StyledButton disabled={disabled} type={type} onClick={onClick}>
      {label}
    </StyledButton>
  );
};

export default Button;
